export const createBrewMenuUnverifiedProductMutation = /* GraphQL */ `mutation createProduct($input: createProduct!) {
	createProduct(input: $input) {
	  id
	  title
	}
  }`
